module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS4.d227f933.jpg";